import React, { useState } from "react";
import {
  Container, CssBaseline, Paper, Typography, TextField,
  Button, Grid, Link, Box, CircularProgress, InputAdornment, IconButton
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import { toast } from "react-toastify";
import api from "../../services/partnerApi";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    padding: theme.spacing(4),
    borderRadius: 20,
    background: "rgba(255,255,255,0.05)",
    backdropFilter: "blur(20px)",
    border: "1px solid rgba(255,255,255,0.1)",
    boxShadow: "0 25px 60px rgba(0,0,0,0.5)",
    color: "#fff",
    maxWidth: 420,
    width: "100%",
  },
  title: {
    fontWeight: 700,
    fontSize: 28,
    background: "linear-gradient(90deg, #f59e0b, #ef4444)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    marginBottom: 4,
  },
  subtitle: { color: "rgba(255,255,255,0.6)", fontSize: 14, marginBottom: theme.spacing(3) },
  input: {
    "& .MuiOutlinedInput-root": {
      color: "#fff",
      "& fieldset": { borderColor: "rgba(255,255,255,0.2)" },
      "&:hover fieldset": { borderColor: "#f59e0b" },
      "&.Mui-focused fieldset": { borderColor: "#f59e0b" },
    },
    "& .MuiInputLabel-root": { color: "rgba(255,255,255,0.5)" },
    "& .MuiInputLabel-root.Mui-focused": { color: "#f59e0b" },
    "& .MuiInputAdornment-root .MuiIconButton-root": { color: "rgba(255,255,255,0.5)" },
    marginBottom: theme.spacing(2),
  },
  btn: {
    background: "linear-gradient(90deg, #f59e0b, #ef4444)",
    color: "#fff",
    fontWeight: 700,
    padding: theme.spacing(1.5),
    borderRadius: 10,
    fontSize: 16,
    marginTop: theme.spacing(1),
    "&:hover": { background: "linear-gradient(90deg, #d97706, #dc2626)" },
  },
  link: { color: "#f59e0b", cursor: "pointer", textDecoration: "none", fontWeight: 600 },
  badge: {
    background: "linear-gradient(90deg, #f59e0b22, #ef444422)",
    border: "1px solid #f59e0b55",
    borderRadius: 12,
    padding: theme.spacing(1.5, 2),
    marginBottom: theme.spacing(3),
    display: "flex",
    alignItems: "center",
    gap: 12,
  },
  badgeText: { color: "rgba(255,255,255,0.8)", fontSize: 13 },
}));

const PartnerLogin = ({ onLogin, onGoRegister }) => {
  const classes = useStyles();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) { toast.error("Preencha todos os campos."); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/partners/login", { email, password });
      localStorage.setItem("partnerToken", data.token);
      localStorage.setItem("partnerData", JSON.stringify(data.partner));
      onLogin(data.partner);
    } catch (err) {
      toast.error(err?.response?.data?.error || "Credenciais inválidas.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={classes.root}>
      <Paper className={classes.paper} elevation={0}>
        <Box textAlign="center" mb={3}>
          <Typography className={classes.title}>ChatPrime</Typography>
          <Typography variant="h6" style={{ color: "#fff", fontWeight: 600 }}>Portal do Representante</Typography>
          <Typography className={classes.subtitle}>Acesse sua conta e gerencie suas indicações</Typography>
        </Box>

        <div className={classes.badge}>
          <span style={{ fontSize: 24 }}>💰</span>
          <Typography className={classes.badgeText}>
            <strong style={{ color: "#f59e0b" }}>Ganhe 50%</strong> da 1ª mensalidade de cada cliente que você indicar!
          </Typography>
        </div>

        <form onSubmit={handleSubmit}>
          <TextField
            label="E-mail"
            variant="outlined"
            fullWidth
            className={classes.input}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            type="email"
            autoFocus
          />
          <TextField
            label="Senha"
            variant="outlined"
            fullWidth
            className={classes.input}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type={showPass ? "text" : "password"}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPass(!showPass)} size="small">
                    {showPass ? <VisibilityOffIcon /> : <VisibilityIcon />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
          <Button type="submit" fullWidth variant="contained" className={classes.btn} disabled={loading}>
            {loading ? <CircularProgress size={22} style={{ color: "#fff" }} /> : "Entrar"}
          </Button>
        </form>

        <Box mt={3} textAlign="center">
          <Typography variant="body2" style={{ color: "rgba(255,255,255,0.5)" }}>
            Não tem conta?{" "}
            <span className={classes.link} onClick={onGoRegister}>
              Cadastre-se como representante
            </span>
          </Typography>
        </Box>
      </Paper>
    </div>
  );
};

export default PartnerLogin;
